import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation } from '@tanstack/react-query'
import { CreateRuleInput } from '../../domain/dtos/create-rule-input'
import { QueryKey } from '../../domain/dtos/query-keys'
import { CreateRule } from '../../usecases/create-rule'

export const useCreateRule = () => {
  const container = useContainer()

  return useMutation(
    [QueryKey.createRule],
    (input: CreateRuleInput) => new CreateRule(container.get(HttpClient)).execute(input),
    {
      retry: false,
    },
  )
}
